const ID = {

  serviceID: "service_8hiprej",
  templateID: "template_5yk398k",
  userID: "user_Qw5MPVW3fetknNSmD1f72",
};

export default ID;
